module.exports = __webpack_public_path__ + "static/media/at.42f206eb.svg";